import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material';

import { checkIfIsArray } from '@e-socna/utils';
import { EMPTY_ARRAY } from '@e-socna/empty';

interface Props {
  readonly children: ReactNode;
  readonly sx?: SxProps<Theme>;
}

export const IllustrationWrapper = ({
  children,
  sx = EMPTY_ARRAY,
}: Readonly<Props>) => (
  <Box
    sx={[
      {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '473px',
        maxWidth: '80vw',
        width: '400px',
        margin: 'auto',
      },
      ...(checkIfIsArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Box>
);
